import React from 'react';
import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import { CollapseWrap, CollapseContainer } from './styles';
import TabsComponent from './../../Components/TabsComponent/TabsComponent.js';
import FeeExpenses from './../../Components/Fee&Expenses/Fee&Expenses.js';
import BalanceDetails from './../../Components/BalanceDetails.js';

const Panel = Collapse.Panel;

const CollapseComponent = (props) => {
    return (
        <CollapseContainer className={props.accordionkey !== "1" ? "mt-20" : null}>
            <CollapseWrap className={props.accordionkey === "2" ? "balanceDetailsSection" : null}>
                <Collapse onChange={props.handleChange} activeKey={props.isOpen ? props.accordionkey : "0"}>
                    <Panel showArrow={false} header={props.title} key={props.accordionkey}>
                        {
                            props.accordionkey === "1" ? <TabsComponent pageTitle={props.pageTitle} filterMaxDate={props.filterMaxDate} filterMinDate={props.filterMinDate} radioChange={props.radioChange} radioValue={props.radioValue} selectedVal={props.selectedVal} /> :
                                props.accordionkey === "3" ? <FeeExpenses pageTitle={props.pageTitle} filterMaxDate={props.filterMaxDate} filterMinDate={props.filterMinDate} selectedVal={props.selectedVal} /> :
                                    <BalanceDetails filterMaxDate={props.filterMaxDate} filterMinDate={props.filterMinDate} selectedVal={props.selectedVal} />
                        }
                    </Panel>
                </Collapse>
            </CollapseWrap>
        </CollapseContainer>
    )
}

CollapseComponent.propTypes = {
    accordionkey: PropTypes.string,
    filterMaxDate: PropTypes.string,
    filterMinDate: PropTypes.string,
    isOpen: PropTypes.bool,
    radioValue: PropTypes.object,
    dropdownValue: PropTypes.arrayOf(PropTypes.string),
    selectedVal: PropTypes.arrayOf(PropTypes.string),
    handleChange: PropTypes.func.isRequired,
    radioChange: PropTypes.func.isRequired
}

export default CollapseComponent;